import React from 'react';

export default function Service({props}) {
  return (
    <div className='services__card'>
      <h3 className='services__title'>{props.title}</h3>
      <span
        onClick={() => {
          props.handleModalInfo({
            modalTitle: props.modalTitle,
            modalSubTitle: props.modalSubTitle,
            content: props.content,
          });
          props.handleModal(true);
        }}
        className='services__button'
      >
        See more
        <i className='bx bx-right-arrow-alt services__icon'></i>
      </span>
    </div>
  );
}
